<template>
  <Modal v-model="isShow" width="75%" :closable="false" :mask-closable="false" styles="overflow-x: hidden;">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">客户分析报告</div>
      <a class="ivu-modal-print" @click="printIt"><i class="ivu-icon ivu-icon-ios-print"></i></a>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <reportContent ref="reportContent"></reportContent>
  </Modal>
</template>

<script>

import reportContent from './report-content'

export default {
  name: 'zhixi-report',
  components: { reportContent },
  data () {
    return {
      form: {},
      barData: {},
      isShow: false,
      type: 'add',
      disable: true,
      showRemoveFile: false
    }
  },
  methods: {
    openModel (type, data) {
      let referrer = document.referrer.toString()
      if (referrer.includes('report')) {
        let referrerIndex = referrer.lastIndexOf('/')
        referrer = referrer.slice(referrerIndex + 1, referrerIndex.length)
      }
      console.log(referrer + 'token:::')
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
      this.dataMap = null
      this.$refs.reportContent.loadData(data.id, null)

      /*  this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
      this.dataMap = null
      this.$refs.reportContent.loadData(data.id) */
    },
    closeModel () {
      this.isShow = false
    },
    printIt () {
      this.$refs.reportContent.printIt()
    }
  },
  mounted: function () {
  }
}
</script>
<style>
.ivu-modal-print {
  margin: 20px 60px 10px 40px;
  z-index: 1;
  font-size: 14px;
  position: absolute;
  right: 8px;
  top: 8px;
  overflow: hidden;
  cursor: pointer;
}
</style>
